import React from 'react';

/**
 * Gets the video id from a youtube url
 * @param {*} url
 */
const getYoutubeVideoId = (url) => {
  // eslint-disable-next-line
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : false;
};

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    autoplay,
    height,
    url,
    width,
  } = this.props; // eslint-disable-line

  if (!url) {
    return false;
  }

  let platform = null;
  let videoId = null;
  if (url.search(/youtube|youtu.be/) !== -1) {
    platform = 'youtube';
    videoId = getYoutubeVideoId(url);
  } else if (url.search(/vimeo/) !== -1) {
    platform = 'vimeo';
    videoId = url.split('/')[3]; // eslint-disable-line
  }

  return (
    <>
      {(platform === 'youtube' && videoId) && (
        <amp-youtube
          autoplay={autoplay}
          data-videoid={videoId}
          height={height || 1}
          layout="responsive"
          width={width || 1.77}
        />
      )}

      {(platform === 'vimeo' && videoId) && (
        <amp-vimeo
          autoplay={autoplay}
          data-videoid={videoId}
          height={height || 1}
          layout="responsive"
          width={width || 1.77}
        />
      )}
    </>
  );
}

export default renderAmp;
